import { Box, Container, Flex, HStack, Heading, Image, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";
import Footer from "./components/Footer";

export default function Landing() {
  return (
    <>
      <Flex as="main" direction="column" minHeight="100vh">
        <Container maxW="7xl">
          <Box>
            <HStack mt="2em">
              <Image
                // src="/logo-bg-dark.png"
                src="/logo-bg-transparent.png"
                boxSize="5em"
                alt="BTFDCA Logo"
                mr="0.5em"
                border="1px solid gold"
                display="inline-block"
              />
              <Text fontSize="8xl" fontWeight="bold">
                BTFDCA Vaults
              </Text>
            </HStack>
            <Text mt="0.5em" fontSize="3xl" fontWeight="bold">
              Deposit [SOURCE TOKEN], sit back, and watch your [TARGET TOKEN] stash grow.
            </Text>
            <Text mt="2.5em" fontSize="md">
              {/* TODO: [i] */}
              Our vaults dollar-cost average for you.
            </Text>
            <Text mt="0.5em" fontSize="md">
              You select the vault with the asset you want to stack and the token to spend, define the duration and
              amount of your spending, and deposit.
            </Text>
            <Text mt="0.5em" fontSize="md">
              BTFDCA periodically swaps the source token for the target token. The assets are held in the vault, until
              you decide to redeem them.
            </Text>
          </Box>

          <HStack mt="5em" spacing="2.5em">
            {/*
          <Box>
            <Text fontSize="xl" fontWeight="bold">
              Create a Vault
            </Text>
            <Box>[CREATE A VAULT]</Box>
          </Box>
          */}
            <Box>
              <Text fontSize="xl" fontWeight="bold">
                Existing Vaults
              </Text>
              <Flex py="1em">
                <LinkBox as="article" maxW="sm" p="5" borderWidth="1px" borderColor="teal.500" rounded="md">
                  <Box>NEW!</Box>
                  <Heading size="md" my="2">
                    <LinkOverlay href="/vaults/0x775e5faab086d8e899d879c83100eaddaa4810f5">USDC/WFTM</LinkOverlay>
                  </Heading>
                  <Text mb="3">Stack WFTM through DCA.</Text>
                </LinkBox>
              </Flex>
            </Box>
          </HStack>
        </Container>
      </Flex>
      <Footer />
    </>
  );
}
